import React from 'react';
import { wrappable } from '../../Utils/ComponentUtils';

function Header() {
  return <h1>WDK</h1>;
}

export default wrappable(Header);
